/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleCalendarStates } from './equipment-schedule-calendar-states';


export interface SearchEquipmentCalendarSchedulesResponseDto { 
    id?: string;
    name?: string | null;
    triggersCount?: number;
    windowStart?: string;
    windowEnd?: string;
    state?: EquipmentScheduleCalendarStates;
    assignedCount?: number;
    createdDate?: string;
    updatedDate?: string | null;
}



